/*
 * 模块: ABAAnalysisList
 * 职责: 数据分析列表页
 * 依赖: antd, react-router-dom, api
 * 导出: ABAAnalysisList
 * 限制: 文件<150行
 */

import React from 'react';
import { BarChartOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/Layout/PageHeader';
import { EmptyState } from '../components/UI/EmptyState';
import { useABAAnalysisList } from './ABAAnalysisList/hooks/useABAAnalysisList';
import { AnalysisStats } from './ABAAnalysisList/components/AnalysisStats';
import { AnalysisTable } from './ABAAnalysisList/components/AnalysisTable';

/**
 * 数据分析列表页面
 * 功能：显示已上传数据的SKU，查看关键词分析结果（热门搜索词 + 搜索查询绩效）
 */
export const ABAAnalysisList: React.FC = () => {
  const navigate = useNavigate();
  const { skus, loading, stats } = useABAAnalysisList();

  const handleViewAnalysis = (skuId: number) => {
    navigate(`/analysis/${skuId}`);
  };

  const handleGoToDataManagement = (skuId: number) => {
    navigate(`/data-management/${skuId}`);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <PageHeader
        title="数据分析"
        subtitle="查看SKU的关键词分析、品牌网络、市场矩阵等数据分析结果"
        icon={<BarChartOutlined />}
        breadcrumbs={[
          { title: '首页', href: '/' },
          { title: '数据分析' },
        ]}
        actions={[
          {
            key: 'manage',
            label: 'SKU管理',
            type: 'default',
            icon: <TeamOutlined />,
            onClick: () => navigate('/sku-management'),
          },
        ]}
      />

      {/* 内容区域 - 可滚动 */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        padding: '24px 32px',
      }}>
        <AnalysisStats stats={stats} loading={loading} />

        {skus.length === 0 && !loading ? (
          <EmptyState
            type="no-data"
            title="还没有SKU数据"
            description="请先在SKU管理页面创建SKU并上传数据"
            action={{
              label: '前往SKU管理',
              onClick: () => navigate('/sku-management'),
            }}
          />
        ) : (
          <AnalysisTable
            skus={skus}
            loading={loading}
            onViewAnalysis={handleViewAnalysis}
            onUploadData={handleGoToDataManagement}
          />
        )}
      </div>
    </div>
  );
};

export default ABAAnalysisList;
